import React, { useState } from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import TopPriceCardMin from '../components/TopPriceCardMin';
import BottomPriceCardMin from '../components/BottomPriceCardMin';

const MainForm = ({ OfferPicked, DominionCheck, ZipCodeUser }) => {
  const [FormState, setFormState] = useState({
    name: '',
    address: '',
    city: '',
    email: '',
    account_number: '',
    apt: '',
    rate: OfferPicked,
    zip: ZipCodeUser,
    telephone: ''
  });

  const [SubmitDisabled, setSubmitDisabled] = useState(false);

  const handleChange = e => {
    setFormState({
      ...FormState,
      [e.target.name]: e.target.value
    });
  };

  console.log(FormState.email);

  const encode = data => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
  };

  const handleSubmit = e => {
    addToMailchimp(FormState.email, {
      FULLNAME: FormState.name,
      PHONE: FormState.telephone,
      ZIP: ZipCodeUser,
      ADDRESS: FormState.address,
      ACCOUNTNUM: FormState.account_number,
      OFFERSELEC: OfferPicked,
      CITY: FormState.city,
      APT: FormState.apt
    });

    setSubmitDisabled(true);
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'Enrollments', ...FormState })
    })
      .then(() => window.open('../ThankYou', '_self'))
      .catch(() => window.open('../Error', '_self'));

    e.preventDefault();
  };
  console.log(FormState);

  return (
    <div className="container mx-auto">
      {DominionCheck === true ? (
        <div>
          <TopPriceCardMin />
        </div>
      ) : (
        <div>
          <BottomPriceCardMin />
        </div>
      )}

      <form
        method="POST"
        target="_self"
        id="Enrollments"
        name="Enrollments"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={handleSubmit}
        class="bg-white pt-4 md:pt-12"
      >
        <input type="hidden" name="form-name" value="Enrollments" />
        <div class="w-full bg-white md:flex md:pb-10 ">
          <div class="md:w-1/2 px-10 grid row-gap-4 md:row-gap-6">
            <div class="md:col-span-2">
              <label for="full_name" class="block text-sm font-medium leading-5 text-gray-700">
                Full name
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="name"
                  name="name"
                  type="text"
                  onChange={handleChange}
                  value={FormState.name}
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                  placeholder="Jane/John Doe"
                  required
                />
              </div>
            </div>

            <div class="sm:col-span-2">
              <label for="address" class="block text-sm font-medium leading-5 text-gray-700">
                Service Address*
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="address"
                  name="address"
                  type="text"
                  onChange={handleChange}
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                  placeholder="Street Address"
                  required
                />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label for="apt" class="block text-sm font-medium leading-5 text-gray-700">
                Apt No. / P.O. Box / Etc.
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="apt"
                  name="apt"
                  type="text"
                  onChange={handleChange}
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                  placeholder="Suite-A"
                />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label for="city" class="block text-sm font-medium leading-5 text-gray-700">
                City
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="city"
                  name="city"
                  type="text"
                  onChange={handleChange}
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                  placeholder="City"
                  required
                />
              </div>
            </div>
          </div>

          <div class="pt-4 md:pt-0 md:w-1/2 px-10 grid row-gap-4 md:row-gap-6">
            <div class="md:col-span-2">
              <label for="account_number" class="block text-sm font-medium leading-5 text-gray-700">
                Utility Account Number
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="account_number"
                  name="account_number"
                  type="number"
                  onChange={handleChange}
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                  placeholder="111111-111111"
                />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
                Email
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="email"
                  name="email"
                  type="email"
                  onChange={handleChange}
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                  placeholder="Sample@gmail.com"
                  required
                />
              </div>
            </div>
            <div class="flex md:col-span-2">
              <div class="w-1/2 mr-2 sm:col-span-2">
                <label for="zip" class="block text-sm font-medium leading-5 text-gray-700">
                  Zip Code
                </label>
                <div class="mt-1 text-green-500 relative rounded-md shadow-sm">
                  <input
                    id="main_zip"
                    name="zip"
                    type="number"
                    value={ZipCodeUser}
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                  />
                </div>
              </div>
              <div class="w-1/2 ml-2 sm:col-span-2">
                <label
                  for="rate_selected"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Rate Selected
                </label>
                <div class="mt-1 relative rounded-md shadow-sm">
                  <input
                    id="rate"
                    name="rate"
                    value={OfferPicked}
                    class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                    placeholder="Dominion/Columbia"
                  />
                </div>
              </div>
            </div>

            <div class="sm:col-span-2">
              <label for="phone" class="block text-sm font-medium leading-5 text-gray-700">
                Telephone
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="phone"
                  name="telephone"
                  type="number"
                  onChange={handleChange}
                  class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
                  placeholder="888-888-8888"
                  required
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container px-3 md:px-10 text-center pb-12 border-b-2 text-gray-600 lg:text-left">
          <p className="text-xs md:text-lg py-8">
            By completing this online Enrollments form you do herby acknowledge and agree with and
            to the below terms and conditions. Should you complete this online Enrollments form and
            HAVE NOT supplied us with your Utility Account Number one of our staff will be in
            contact within the next 24-72 hours to obtain from you or you will also have the ability
            to enter your account number online upon completion of this Enrollments form.
          </p>

          <div class="py-2">
            <div class="flex items-center">
              <input
                id="remember_me_a"
                type="checkbox"
                required
                class="form-checkbox h-6 w-6 border-solid border-1 bg-gray-100 border-gray-900 text-blue transition duration-150 ease-in-out"
              />
              <label
                for="remember_me"
                class="ml-2 block text-xs md:text-sm leading-5 text-gray-500"
              >
                <p>
                  I UNDERSTAND THAT I AM PURCHASING A VARIABLE GAS PRODUCT AND HAVE READ AND AGREE
                  TO THE KRATOS GAS & POWER TERMS OF SERVICE
                </p>
              </label>
            </div>
          </div>

          <div class="py-2">
            <div class="flex items-center">
              <input
                id="remember_me_b"
                type="checkbox"
                required
                class="form-checkbox h-6 w-6 border-solid border-1 bg-gray-100 border-gray-900 text-blue transition duration-150 ease-in-out"
              />
              <label
                for="remember_me"
                class="ml-2 block text-xs md:text-sm leading-5 text-gray-500"
              >
                <p>
                  I AM AN AUTHORIZED DECISION MAKER FOR THIS ACCOUNT AND THAT I AM OVER 18 YEARS OF
                  AGE?
                </p>
              </label>
            </div>
          </div>

          <div class="py-2">
            <div class="flex items-center">
              <input
                id="remember_me_c"
                type="checkbox"
                required
                class="form-checkbox h-6 w-6 border-solid border-1 bg-gray-100 border-gray-900 text-blue transition duration-150 ease-in-out"
              />
              <label
                for="remember_me"
                class="ml-2 block text-xs md:text-sm leading-5 text-gray-500"
              >
                <p>
                  I UNDERSTAND THAT MY INTRODUCTORY RATE IS FOR THE CONTRACTED PERIOD OF TIME AND
                  WILL REVERT TO A VARIABLE RATE AND I CAN CANCEL AT ANY TIME?
                </p>
              </label>
            </div>
          </div>

          {SubmitDisabled === true ? (
            <div>
              <button
                type="submit"
                class="mt-10 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base leading-6 font-medium rounded-card text-white bg-blue"
              >
                Please Wait....
              </button>
            </div>
          ) : (
            <div>
              <button
                type="submit"
                class="mt-10 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base leading-6 font-medium rounded-card text-white bg-red hover:bg-blue focus:outline-none focus:border-blue focus:shadow-outline-indigo active:bg-blue transition ease-in-out duration-500"
              >
                Submit
              </button>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default MainForm;
